export const ACRONYMS = ['MFA', 'LT', 'ACH', 'YET', 'TPA'];
